import React from 'react';

import { useAppSelector } from '../../hooks';
import { TooltipTextContent } from './common';

export function CeilingPlaneTooltip(props: { guid: string }) {
  const ceilingPlane = useAppSelector((state) => state.layout.ceilingPlanes[props.guid]);

  if (ceilingPlane == null) {
    console.warn('unable to find ceiling plane for tooltip.');
    return null;
  }

  return <TooltipTextContent text={`Ceiling Plane with ${ceilingPlane.cuts.length} cuts`} />;
}
